import styled from 'styled-components';

import { useBreakPoint } from '../../hooks/useBreakPoint';
import useTenantUser from '../../hooks/useTenantUser';
import UserProfileCircle from '../_atoms/UserProfileCircle';

export const WorkspaceUser = ({ uid, showName }: { uid: string; showName?: boolean }) => {
  const { user } = useTenantUser(uid);
  const isDesktop = useBreakPoint(1200);
  if (!user) return null;
  return (
    <CreatedByContainer style={{ display: 'flex' }}>
      <UserProfileCircle uid={uid} userName={user.username} radius={30} />
      {(isDesktop || showName) && (
        <span style={{ marginLeft: '10px' }}>{user.username}</span>
      )}
    </CreatedByContainer>
  );
};

const CreatedByContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-evenly;
`;
